module.exports = __webpack_public_path__ + "assets/images/book_9cd7dacd02c2e03679b3a5b9c3eb1273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/locales/sul/book.png
// module id = 207
// module chunks = 0